<div class="form-group">
    <span class="icon id-number"></span>
    <div class="inputs">
        <label for="cpf-clientef">Renavam</label>
        <input #renavanInput name="renavam" type="text" [justNumber]="true" class="form-control" [(ngModel)]="fichaCadastro.codRenavam" placeholder="Digite o Renavam (opcional)" uppercase maxlength="11" (blur)="validaRenavam()" />
    </div>
</div>
<h2>Observações</h2>
<div class="row">
    <div class="col-xs-12">
        <div class="form-group text-box column-custom">
            <textarea name="observacao" [(ngModel)]="observacao" (ngModelChange)="onChangeObs(observacao)" id="user-observations" class="form-control" cols="30" rows="10" maxlength="2000"></textarea>
            <h5 class="caracteres">{{ countCaracteres }} / 2000</h5>
        </div>
    </div>
</div>
<div *ngIf="!fichaCadastro.getAvalista()" class="row">
        <div class="marginT30 form-group tab-buttons">
          <a (click)="abrirInclusaoAvalista()" class="bt-back btn btn-border-orange pull-left">
            <em class="fa fa-user mrBt"></em> Incluir Avalista</a>
         </div>
      </div>
<div class="row">
    <div class="marginT30 form-group tab-buttons">
        <a (click)="onClickPrevious()" class="bt-back btn btn-border-orange pull-left">
            <em class="fa fa-arrow-left mrBt"></em> Voltar</a>
        <a (click)="onClickNext()" class="bt-go btn btn-full-orange pull-right">Continuar
            <em class="fa fa-arrow-right mlBt"></em>
        </a>
    </div>
</div>

<!-- MODAL -->
<app-modal-message #modalMessage [hideClose]="hideClose" title="Atenção!">
</app-modal-message>

<app-loader-circles *ngIf="isLoading"></app-loader-circles>
